export default {
    SECTION_WIDGET_PRODUCT_BRAND: {
        1:{
            container: {
                cellWidth:{
                    100: {
                        allow: true,
                        item: 6,
                      },
                      66.67: {
                        allow: true,
                        item: 3,
                      },
                      58.33: {
                        allow: true,
                        item: 3,
                      },
                      50: {
                        allow: true,
                        item: 3,
                      },
                      41.67: {
                        allow: true,
                        item: 2,
                      },
                      33.33: {
                        allow: true,
                        item: 2,
                      },
                      25: {
                        allow: true,
                        item: 1,
                      },
                      20: {
                        allow: true,
                        item: 1,
                      },
                      16.66: {
                        allow: true,
                        item: 1,
                      },
                }
            },
            "container-fluid": {
                cellWidth:{
                    100: {
                        allow: true,
                        item: 8,
                      },
                      66.67: {
                        allow: true,
                        item: 4,
                      },
                      58.33: {
                        allow: true,
                        item: 4,
                      },
                      50: {
                        allow: true,
                        item: 4,
                      },
                      41.67: {
                        allow: true,
                        item: 3,
                      },
                      33.33: {
                        allow: true,
                        item: 3,
                      },
                      25: {
                        allow: true,
                        item: 2,
                      },
                      20: {
                        allow: true,
                        item: 2,
                      },
                      16.66: {
                        allow: true,
                        item: 1,
                      },

                }
            }
        },
        2:{
            container: {
                cellWidth:{
                    100: {
                        allow: true,
                        item: 6,
                      },
                      66.67: {
                        allow: true,
                        item: 3,
                      },
                      58.33: {
                        allow: true,
                        item: 3,
                      },
                      50: {
                        allow: true,
                        item: 3,
                      },
                      41.67: {
                        allow: true,
                        item: 2,
                      },
                      33.33: {
                        allow: true,
                        item: 2,
                      },
                      25: {
                        allow: true,
                        item: 1,
                      },
                      20: {
                        allow: true,
                        item: 1,
                      },
                      16.66: {
                        allow: true,
                        item: 1,
                      },
                }
            },
            "container-fluid": {
                cellWidth:{
                    100: {
                        allow: true,
                        item: 8,
                      },
                      66.67: {
                        allow: true,
                        item: 4,
                      },
                      58.33: {
                        allow: true,
                        item: 4,
                      },
                      50: {
                        allow: true,
                        item: 4,
                      },
                      41.67: {
                        allow: true,
                        item: 3,
                      },
                      33.33: {
                        allow: true,
                        item: 3,
                      },
                      25: {
                        allow: true,
                        item: 2,
                      },
                      20: {
                        allow: true,
                        item: 2,
                      },
                      16.66: {
                        allow: true,
                        item: 1,
                      },

                }
            }
        }
    }
}